import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Row } from "react-bootstrap";

interface DommusInputErroProps {
    mensagem?: string
}

export function DommusInputErro({mensagem="Campo Obrigatório!"}: DommusInputErroProps) {
    return (
        <Row className="ml-2">
            <FontAwesomeIcon 
                icon={faExclamationTriangle as IconProp} 
                color="#DC3545" 
                className="mr-2 mt-2"
            /> <small className="form-text text-danger mt-2">{mensagem}</small>
        </Row>
    )
}